import "./_we-nav-panel-1.scss";
import { gsap } from 'gsap';
/* 
JS DEPENDECIES: GSAP
*/

	const homePageHeader = $(".home #masthead");
	const pageHeader = $("#masthead");
	var navPanelId = "#we-nav-panel-1";
	var headerHeight = homePageHeader.outerHeight();
	var screenHeigth = $(window).innerHeight();
	var wpAdminBar;
	var avilableSpaceBelowHeader = screenHeigth - (headerHeight + wpAdminBar);

	var ssNavLinks = $("ul#primary-menu-small-screen a");

	if ($("#wpadminbar").length > 0) {
		wpAdminBar = $("#wpadminbar").outerHeight();
	} else {
		wpAdminBar = 0;
	}
		//OPENING ANIM INIT
		var navPanelOpeningAnim = gsap.timeline({
			repeat: 0,
			repeatDelay: 1,
			paused: true,
		});
	//OPENING ANIM SET
	navPanelOpeningAnim.set(navPanelId, {
		display: "none",
		top: headerHeight + wpAdminBar,
	});
	navPanelOpeningAnim.set(navPanelId, {
		display: "block",
		top: headerHeight + wpAdminBar,
	});
	navPanelOpeningAnim.to(navPanelId, {
		duration: 0.4,
		opacity: "1",
	});
	navPanelOpeningAnim.to(
		homePageHeader,
		{
			duration: 0.4,
			backgroundColor: "#000324",
		},
		0
	);
	navPanelOpeningAnim.to(
		$("body"),
		{
			duration: 0.4,
			backgroundColor: "#000324",
		},
		0
	);

	$(ssNavLinks).each(function (index, element) {
		// element == this
		navPanelOpeningAnim.to($(element), {
			duration: 0.1,
			opacity: "1",
			x: 0,
		});
	});
	//END OPENING ANIM SET

	export function weNavPanel1Open() {
		//PANEL SWITCHER SHOULD CALL THIS FUNCTION
		navPanelOpeningAnim.play();
	}
	export function weNavPanel1Close() {
		//PANEL SWITCHER SHOULD CALL THIS FUNCTION
		navPanelOpeningAnim.reverse();
	}
$(function () {
	$(window).resize(function () {
		headerHeight = homePageHeader.outerHeight();
		screenHeigth = $(window).innerHeight();
		avilableSpaceBelowHeader = screenHeigth - (headerHeight + wpAdminBar);

		gsap.set(navPanelId, {
			top: headerHeight + wpAdminBar,
		});
	});
});
